export const styleConstant = {
  menuTopHeight: 60,
  topPageNameHeight: 112,
  outputPageLeftMenuWidth: 288,

  topFilterHeightBeforeScrollDownActionGenreOutput: 212,
  topFilterHeightAfterScrollDown: 84,

  topFilterImageUploadPage: 221, // 이미지 업로드/정보 수정 페이지의 상단부 height + border 1px
  fileSelectButtonLayoutImageUploadPage: 76, // 이미지 업로드/정보 수정 페이지의 '파일 직접 선택' 버튼이 위치하는 frame의 height

  zIndexTopFilter: 1,
  zIndexChip: 2,
  zIndexChipPaper: 3,
  zIndexMenuTop: 4,
  zIndexModal: 5,
  zIndexToast: 6
};
